export const triggerAnalytics = (key = 'click', payload) => {
  return window?.LIFE_CYCLE_EVENT_BUS?.trigger?.(`questions-and-answers.${key}`, payload);
};